/* Siciliano Store — script del tema «Mediterraneo premium» */
(function () {
  'use strict';

  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    var s = n.toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s.join(',') + ' €';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ss-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* ---------- Carrello ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-ss-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
    document.querySelectorAll('[data-ss-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Carrello, ' + n + (n === 1 ? ' articolo' : ' articoli'));
    });
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }
  function addToCart(variantId, qty) {
    return fetch((window.ssTheme && ssTheme.cartAddUrl ? ssTheme.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Non è stato possibile aggiungere il prodotto.');
        return j;
      });
    }).then(function (j) {
      refreshCount();
      var cartUrl = (window.ssTheme && ssTheme.cartUrl) || '/cart';
      toast('<span>Aggiunto al carrello</span><a href="' + cartUrl + '">Vai al carrello →</a>');
      return j;
    });
  }
  window.ssAddToCart = addToCart;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ss-add]')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-ss-msg]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (msg) msg.textContent = '';
    addToCart(idInput.value, 1).catch(function (err) {
      if (msg) msg.textContent = err.message; else toast('<span>' + esc(err.message) + '</span>');
    }).then(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.hasAttribute('data-ss-soldout'); }
    });
  });

  /* ---------- Preferiti ---------- */
  function liked() { return store.get('ss_liked', []); }
  function isLiked(id) { return liked().some(function (x) { return String(x.id) === String(id); }); }
  function toggleLike(item) {
    var list = liked();
    var i = list.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (i > -1) list.splice(i, 1); else list.unshift(item);
    store.set('ss_liked', list.slice(0, 60));
    syncLikes();
    return i === -1;
  }
  function syncLikes() {
    document.querySelectorAll('[data-ss-like]').forEach(function (b) {
      b.setAttribute('aria-pressed', isLiked(b.getAttribute('data-ss-like')) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ss-liked-count]').forEach(function (el) { el.textContent = liked().length; });
    document.dispatchEvent(new CustomEvent('ss:liked'));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ss-like]');
    if (!b) return;
    e.preventDefault();
    var added = toggleLike({
      id: b.getAttribute('data-ss-like'), url: b.dataset.url, img: b.dataset.img,
      brand: b.dataset.brand, name: b.dataset.name, price: b.dataset.price
    });
    toast(added ? '<span>Salvato nei preferiti</span><a href="/pages/swipe#preferiti">Vedi →</a>' : '<span>Tolto dai preferiti</span>');
  });

  /* ---------- Taglia consigliata ---------- */
  function profile() { return store.get('ss_taglia', null); }
  var ALPHA = /^(XXS|XS|S|M|L|XL|XXL|XXXL|3XL|4XL)$/i;
  function isMine(value, kind) {
    var p = profile();
    if (!p) return false;
    var v = String(value).trim().toUpperCase().replace(',', '.');
    if (ALPHA.test(v)) return p.alpha && v === String(p.alpha).toUpperCase();
    var n = parseFloat(v);
    if (isNaN(n)) return false;
    if (kind === 'shoe') return p.shoe && Math.abs(n - parseFloat(p.shoe)) < 0.01;
    return (p.it && n === Number(p.it)) || (p.jeans && n === Number(p.jeans));
  }
  window.ssIsMine = isMine;

  /* ---------- Scheda prodotto ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-ss-variants]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = root.querySelector('form[data-ss-add]');
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var priceBox = root.querySelector('#ss-price');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ss-opt]'));
    var hint = root.querySelector('[data-ss-size-hint]');
    var gallery = root.querySelector('[data-ss-gallery]');
    var stickyPrice = root.querySelector('[data-ss-sticky-price]');

    function selected() {
      return groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(sel) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      });
    }
    function exact(sel) {
      if (!groups.length) return data.variants[0];
      if (sel.some(function (s) { return s == null; })) return null;
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); });
    }
    function refreshAvailability(sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.ss-opt__val').forEach(function (lab) {
          var input = lab.querySelector('input');
          var test = sel.slice();
          test[gi] = input.value;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || test[i] === o; });
          });
          lab.classList.toggle('is-out', !ok);
        });
      });
    }
    /* La foto da mostrare per una selezione anche solo parziale.
       Con il colore scelto e la taglia ancora no, `exact()` non trova nulla,
       ma il colore sì: si prende la prima variante di quel colore che abbia
       una foto, preferendone una disponibile. */
    function mediaFor(sel) {
      var match = data.variants.filter(function (v) {
        return v.media != null && v.options.every(function (o, i) {
          return sel[i] == null || sel[i] === o;
        });
      });
      return match.find(function (v) { return v.available; }) || match[0] || null;
    }

    /* Porta in vista la foto della variante.
       Mobile: la galleria è uno scroller orizzontale, quindi ci si scorre.
       Desktop: è una griglia che mostra già tutte le foto insieme, quindi
       l'unico modo di "cambiare immagine" è spostare in testa quella scelta.
       Deve essere uno spostamento nel DOM e non un `order`: la regola che
       allarga la prima foto è `.ss-gallery__item:first-child`, e `order` non
       la tocca. */
    function showMedia(variant) {
      if (!gallery || !variant || variant.media == null) return;
      var item = gallery.querySelector('[data-media-pos="' + variant.media + '"]');
      if (!item) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      } else if (gallery.firstElementChild !== item) {
        gallery.insertBefore(item, gallery.firstElementChild);
      }
    }

    function render() {
      var sel = selected();
      refreshAvailability(sel);
      var v = exact(sel);
      var needSize = sel.some(function (s) { return s == null; });
      if (!v) {
        idInput.value = '';
        btn.disabled = true;
        btn.removeAttribute('data-ss-soldout');
        btn.textContent = needSize ? 'Scegli la taglia' : 'Non disponibile';
        showMedia(mediaFor(sel));
        return;
      }
      idInput.value = v.id;
      if (v.available) {
        btn.disabled = false;
        btn.removeAttribute('data-ss-soldout');
        btn.textContent = 'Aggiungi al carrello';
      } else {
        btn.disabled = true;
        btn.setAttribute('data-ss-soldout', '');
        btn.textContent = 'Esaurito in questa taglia';
      }
      var html = '<span class="ss-price__now">' + money(v.price) + '</span>';
      if (v.compare > v.price) {
        var save = v.compare - v.price;
        html += '<s class="ss-price__was"><span class="ss-vh">Prezzo di listino</span>' + money(v.compare) + '</s>' +
          '<span class="ss-price__save">Risparmi ' + money(save) + ' (−' + Math.floor(save * 100 / v.compare) + '%)</span>';
      }
      if (priceBox) {
        priceBox.innerHTML = html;
        priceBox.classList.toggle('ss-price--sale', v.compare > v.price);
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      } catch (e) {}
      showMedia(v);
    }
    groups.forEach(function (g) { g.addEventListener('change', render); });

    // taglia consigliata
    var sizeGroup = root.querySelector('[data-ss-opt][data-size-kind]');
    var p = profile();
    if (sizeGroup) {
      var kind = sizeGroup.getAttribute('data-size-kind');
      var mineInput = null;
      sizeGroup.querySelectorAll('.ss-opt__val').forEach(function (lab) {
        var inp = lab.querySelector('input');
        if (isMine(inp.value, kind)) { lab.classList.add('is-mine'); mineInput = mineInput || inp; }
      });
      if (hint) {
        if (p && mineInput) {
          hint.innerHTML = '<svg class="ss-icon ss-icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>Ti consigliamo la <strong>' + esc(mineInput.value) + '</strong> in base al tuo test. <a href="' + ssTheme.tagliaUrl + '">Rifai il test</a></span>';
        } else if (p) {
          hint.innerHTML = '<span>Il tuo test dice <strong>' + esc(kind === 'shoe' ? (p.shoe || '—') : (p.alpha + ' / ' + p.it)) + '</strong>: per questo capo controlla la vestibilità o <a href="https://wa.me/' + ssTheme.whatsapp + '" target="_blank" rel="noopener">chiedici su WhatsApp</a>.</span>';
        }
      }
      var hasVariantParam = /[?&]variant=/.test(location.search);
      if (mineInput && !hasVariantParam && !sizeGroup.querySelector('input:checked')) {
        var test = selected();
        var gi = groups.indexOf(sizeGroup);
        test[gi] = mineInput.value;
        var cand = findVariant(test);
        if (cand && cand.available) mineInput.checked = true;
      }
    }
    render();

    // pallini galleria mobile
    if (gallery) {
      var dots = root.querySelectorAll('[data-ss-dots] span');
      if (dots.length) {
        gallery.addEventListener('scroll', function () {
          var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        }, { passive: true });
      }
    }
  }

  /* ---------- Header ---------- */
  function initHeader() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details[data-ss-close][open]').forEach(function (d) { d.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('details[data-ss-close][open]').forEach(function (d) {
        if (!d.contains(e.target) || (e.target.closest && e.target.closest('[data-ss-scrim]'))) d.removeAttribute('open');
      });
    });
    document.querySelectorAll('details[data-ss-close]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        document.querySelectorAll('details[data-ss-close][open]').forEach(function (o) { if (o !== d && !o.contains(d)) o.removeAttribute('open'); });
        var f = d.querySelector('input[type="search"]');
        if (f) setTimeout(function () { f.focus(); }, 30);
        if (d.hasAttribute('data-ss-lock')) document.documentElement.style.overflow = 'hidden';
      });
      d.addEventListener('toggle', function () {
        if (!d.open && d.hasAttribute('data-ss-lock')) document.documentElement.style.overflow = '';
      });
    });
    // mega menu da tastiera / touch
    document.querySelectorAll('.ss-nav__item[data-has-mega] > .ss-nav__link').forEach(function (a) {
      a.addEventListener('touchstart', function (e) {
        var item = a.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          document.querySelectorAll('.ss-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
      }, { passive: false });
    });
  }

  /* ---------- Collezione: ordinamento ---------- */
  function initCollection() {
    document.querySelectorAll('[data-ss-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { el.form.submit(); });
    });
  }

  /* ---------- Trova la tua taglia ---------- */
  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('.ss-quiz__step'));
    var bar = root.querySelector('.ss-quiz__bar span');
    var state = Object.assign({ gender: 'uomo', height: 175, weight: 75, fit: 'regolare', shoe: '' }, store.get('ss_taglia_input', {}));
    var idx = 0, started = false;
    function show(i) {
      idx = Math.max(0, Math.min(steps.length - 1, i));
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      if (bar) bar.style.width = ((idx + 1) / steps.length * 100) + '%';
      var h = steps[idx].querySelector('h2');
      if (h && started) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      started = true;
    }
    root.querySelectorAll('[data-q]').forEach(function (b) {
      var k = b.getAttribute('data-q'), v = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', String(state[k]) === v ? 'true' : 'false');
      b.addEventListener('click', function () {
        state[k] = v;
        root.querySelectorAll('[data-q="' + k + '"]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (k === 'gender') setRanges();
        setTimeout(function () { show(idx + 1); }, 160);
      });
    });
    function bindRange(name) {
      var r = root.querySelector('input[name="' + name + '"]');
      var o = root.querySelector('output[for="' + r.id + '"]');
      r.value = state[name];
      var unit = r.getAttribute('data-unit') || '';
      o.textContent = r.value + ' ' + unit;
      r.addEventListener('input', function () { state[name] = Number(r.value); o.textContent = r.value + ' ' + unit; });
    }
    function setRanges() {
      var w = root.querySelector('input[name="weight"]');
      if (state.gender === 'donna') { w.min = 38; w.max = 120; } else { w.min = 48; w.max = 150; }
    }
    setRanges();
    bindRange('height');
    bindRange('weight');
    var shoeSel = root.querySelector('select[name="shoe"]');
    if (shoeSel) { shoeSel.value = state.shoe || ''; shoeSel.addEventListener('change', function () { state.shoe = shoeSel.value; }); }
    root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { show(idx + 1); }); });
    root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { show(idx - 1); }); });
    var resultBox = root.querySelector('[data-ss-result]');
    root.querySelector('[data-ss-calc]').addEventListener('click', function () {
      var A = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
      var w = state.weight, h = state.height, i;
      if (state.gender === 'donna') {
        i = w < 50 ? 0 : w < 58 ? 1 : w < 66 ? 2 : w < 75 ? 3 : w < 85 ? 4 : w < 96 ? 5 : 6;
        if (h >= 178 && i < 6) i++;
      } else {
        i = w < 60 ? 0 : w < 69 ? 1 : w < 78 ? 2 : w < 88 ? 3 : w < 99 ? 4 : w < 111 ? 5 : 6;
        if (h >= 190 && i < 6) i++;
        if (h < 165 && i > 0 && w < 80) i--;
      }
      if (state.fit === 'aderente' && i > 0) i--;
      if (state.fit === 'comoda' && i < 6) i++;
      var IT = state.gender === 'donna' ? [38, 40, 42, 44, 46, 48, 50] : [44, 46, 48, 50, 52, 54, 56];
      var J = state.gender === 'donna' ? [25, 26, 28, 30, 32, 34, 36] : [29, 30, 32, 34, 36, 38, 40];
      var res = { gender: state.gender, alpha: A[i], it: IT[i], jeans: J[i], shoe: state.shoe || '' };
      store.set('ss_taglia', res);
      store.set('ss_taglia_input', state);
      resultBox.querySelector('[data-r="alpha"]').textContent = res.alpha;
      resultBox.querySelector('[data-r="it"]').textContent = res.it;
      resultBox.querySelector('[data-r="jeans"]').textContent = res.jeans;
      resultBox.querySelector('[data-r="shoe"]').textContent = res.shoe || '—';
      var go = resultBox.querySelector('[data-r="go"]');
      if (go) go.href = state.gender === 'donna' ? go.getAttribute('data-donna') : go.getAttribute('data-uomo');
      show(steps.length - 1);
    });
    var saved = store.get('ss_taglia', null);
    var savedBox = root.querySelector('[data-ss-saved]');
    if (saved && savedBox) {
      savedBox.hidden = false;
      savedBox.querySelector('strong').textContent = saved.alpha + ' · IT ' + saved.it + ' · jeans ' + saved.jeans + (saved.shoe ? ' · scarpe ' + saved.shoe : '');
    }
    show(0);
  }

  /* ---------- Swipe ---------- */
  function initSwipe(root) {
    var dataEl = root.querySelector('#ss-swipe-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var stack = root.querySelector('[data-ss-stack]');
    var likedBox = root.querySelector('[data-ss-liked]');
    var p = profile();
    var deckName = (p && p.gender === 'donna') ? 'donna' : 'uomo';
    var seen = store.get('ss_swipe_seen', {});
    var deck = [];
    var current = null;
    var chosen = null;

    function buildDeck() {
      var all = (data[deckName] || []).slice();
      var unseen = all.filter(function (x) { return !seen[x.id]; });
      deck = unseen.length ? unseen : all;
      if (!unseen.length) { seen = {}; store.set('ss_swipe_seen', seen); }
      root.querySelectorAll('[data-deck]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-deck') === deckName ? 'true' : 'false'); });
      renderStack();
    }
    function cardHTML(x, top) {
      var sizes = '';
      if (x.sizes && x.sizes.length > 1) {
        sizes = '<div class="ss-sw-sizes" role="group" aria-label="Taglia">' + x.sizes.map(function (s) {
          var mine = isMine(s.t, x.shoe ? 'shoe' : '') ? ' is-mine' : '';
          return '<button type="button" class="' + mine + '" data-vid="' + s.id + '" aria-pressed="false"' + (s.a ? '' : ' disabled') + '>' + esc(s.t) + '</button>';
        }).join('') + '</div>';
      }
      var price = '<span><strong>' + money(x.price) + '</strong>' + (x.compare > x.price ? ' <s class="ss-muted">' + money(x.compare) + '</s> <span style="color:var(--ss-ok);font-weight:600">−' + money(x.compare - x.price) + '</span>' : '') + '</span>';
      return '<div class="ss-sw-card"' + (top ? '' : ' aria-hidden="true"') + ' data-id="' + x.id + '">' +
        '<img src="' + esc(x.img) + '" alt="' + esc(x.brand + ' ' + x.name) + '" draggable="false">' +
        '<span class="ss-sw-stamp ss-sw-stamp--like">MI PIACE</span><span class="ss-sw-stamp ss-sw-stamp--nope">NO</span>' +
        '<div class="ss-sw-card__info"><span class="ss-sw-card__brand">' + esc(x.brand) + '</span>' +
        '<a class="ss-sw-card__name" href="' + esc(x.url) + '">' + esc(x.name) + '</a>' + price + sizes + '</div></div>';
    }
    function renderStack() {
      chosen = null;
      if (!deck.length) {
        stack.innerHTML = '<div class="ss-sw-done"><h2 class="ss-h3">Hai visto tutto!</h2><p>Torna domani per i nuovi arrivi, o guarda i tuoi preferiti qui sotto.</p><a class="ss-btn ss-btn--blu" href="' + (deckName === 'donna' ? '/collections/donna-tutti-i-capi' : '/collections/uomo-tutti-i-capi') + '">Vedi tutto il catalogo</a></div>';
        current = null;
        return;
      }
      var view = deck.slice(0, 3);
      stack.innerHTML = view.map(function (x, i) { return cardHTML(x, i === 0); }).reverse().join('');
      var cards = stack.querySelectorAll('.ss-sw-card');
      cards.forEach(function (c, i) {
        var depth = cards.length - 1 - i;
        c.style.transform = 'translateY(' + (depth * 10) + 'px) scale(' + (1 - depth * 0.04) + ')';
        c.style.zIndex = 10 - depth;
      });
      current = cards[cards.length - 1];
      var x = deck[0];
      if (x.sizes && x.sizes.length === 1) chosen = x.sizes[0].a ? x.sizes[0].id : null;
      current.querySelectorAll('.ss-sw-sizes button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          chosen = b.getAttribute('data-vid');
          current.querySelectorAll('.ss-sw-sizes button').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        });
      });
      bindDrag(current);
    }
    function next(dir, skipLike) {
      if (!current || !deck.length) return;
      var x = deck[0];
      seen[x.id] = 1;
      store.set('ss_swipe_seen', seen);
      if (dir > 0 && !skipLike && !isLiked(x.id)) {
        toggleLike({ id: x.id, url: x.url, img: x.img, brand: x.brand, name: x.name, price: money(x.price) });
      }
      current.style.transform = 'translateX(' + (dir * 140) + '%) rotate(' + (dir * 18) + 'deg)';
      current.style.opacity = '0';
      current = null;
      setTimeout(function () { deck.shift(); renderStack(); }, 260);
    }
    function bindDrag(card) {
      var sx = 0, sy = 0, dx = 0, dragging = false, id = null;
      var like = card.querySelector('.ss-sw-stamp--like'), nope = card.querySelector('.ss-sw-stamp--nope');
      card.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button, a')) return;
        dragging = true; id = e.pointerId; sx = e.clientX; sy = e.clientY; dx = 0;
        card.classList.add('is-drag');
        try { card.setPointerCapture(id); } catch (err) {}
      });
      card.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - sx;
        var dy = e.clientY - sy;
        if (Math.abs(dy) > Math.abs(dx) * 1.4 && Math.abs(dx) < 12) return;
        card.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 18) + 'deg)';
        like.style.opacity = Math.max(0, Math.min(1, dx / 90));
        nope.style.opacity = Math.max(0, Math.min(1, -dx / 90));
      });
      function end() {
        if (!dragging) return;
        dragging = false;
        card.classList.remove('is-drag');
        if (dx > 100) next(1);
        else if (dx < -100) next(-1);
        else { card.style.transform = ''; like.style.opacity = 0; nope.style.opacity = 0; }
      }
      card.addEventListener('pointerup', end);
      card.addEventListener('pointercancel', end);
    }
    root.querySelector('[data-sw="nope"]').addEventListener('click', function () { next(-1); });
    root.querySelector('[data-sw="like"]').addEventListener('click', function () { next(1); });
    root.querySelector('[data-sw="cart"]').addEventListener('click', function () {
      if (!deck.length) return;
      var x = deck[0];
      if (!chosen) {
        toast('<span>Scegli prima la taglia sulla card</span>');
        var s = current && current.querySelector('.ss-sw-sizes');
        if (s) s.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
        return;
      }
      addToCart(chosen, 1).then(function () { next(1, true); }).catch(function (err) { toast('<span>' + esc(err.message) + '</span>'); });
    });
    root.querySelectorAll('[data-deck]').forEach(function (b) {
      b.addEventListener('click', function () { deckName = b.getAttribute('data-deck'); buildDeck(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') next(-1);
      if (e.key === 'ArrowRight') next(1);
    });
    function renderLiked() {
      if (!likedBox) return;
      var list = liked();
      if (!list.length) {
        likedBox.innerHTML = '<p class="ss-muted">Ancora nessun preferito: scorri a destra i capi che ti piacciono.</p>';
        return;
      }
      likedBox.innerHTML = '<div class="ss-liked">' + list.map(function (x) {
        return '<a href="' + esc(x.url) + '"><img src="' + esc(x.img) + '" alt="" loading="lazy"><span><b>' + esc(x.brand) + '</b><br>' + esc(x.name) + '</span><span>' + esc(x.price || '') + '</span></a>';
      }).join('') + '</div>';
    }
    document.addEventListener('ss:liked', renderLiked);
    renderLiked();
    buildDeck();
  }

  /* ---------- Avvio ---------- */
  function boot() {
    initHeader();
    initCollection();
    syncLikes();
    document.querySelectorAll('[data-ss-product]').forEach(initProduct);
    document.querySelectorAll('[data-ss-quiz]').forEach(initQuiz);
    document.querySelectorAll('[data-ss-swipe]').forEach(initSwipe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
